import { render, staticRenderFns } from "./BaseSheet.vue?vue&type=template&id=2d461e3c&scoped=true"
import script from "./BaseSheet.vue?vue&type=script&lang=js"
export * from "./BaseSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d461e3c",
  null
  
)

export default component.exports